/**
 * JA (01-08-23)
 * Font type pattern matching algorithm referenced from here:
 * https://mimesniff.spec.whatwg.org/#matching-a-font-type-pattern
 */
const bytePatternList = [
  {
    mime: "font/ttf",
    pattern: "00010000",
  },
  {
    mime: "font/otf",
    pattern: "4F54544F",
  },
  {
    mime: "font/collection",
    pattern: "74746366",
  },
  {
    mime: "font/woff",
    pattern: "774F4646",
  },
  {
    mime: "font/woff2",
    pattern: "774F4632",
  },
];

/**
 * JA (01-08-23)
 * Header-inspecting method to determine the mime type of a uploaded file by comparing magic numbers in the first few bytes.
 * Reads the first 4 bytes of a File object and returns them as a lowercase hexadecimal string.
 * https://en.wikipedia.org/wiki/Magic_number_%28programming%29
 */
const getFontFileMagicNumber = async (file: File): Promise<string> => {
  return file
    .slice(0, 4) /** Slice the first 4 bytes of the file using the File's slice method and read as an ArrayBuffer */
    .arrayBuffer()
    .then(
      (buffer) =>
        Array.from(new Uint8Array(buffer)) /** Create a Uint8Array from the ArrayBuffer and convert it to an array of bytes (numbers) */
          .map((byte) => byte.toString(16).padStart(2, "0")) /** Convert each byte to its hexadecimal representation as a string and pad it with zeros if necessary */
          .join("")
          .toUpperCase() /** Join the hexadecimal strings to create the final lowercase hexadecimal string. */,
    );
};
/**
 * Finds the matching object from the bytePatternList
 * The chosen object's mime key's value is returned
 */
export const getFontMimeType = async (file: File): Promise<string> => {
  const readPattern = await getFontFileMagicNumber(file);
  const matchingMimeType = bytePatternList.find((item) => item.pattern === readPattern);
  return matchingMimeType!.mime;
};
